import { useRef } from "react";
import { Box, Sheet, Stack, Typography, Chip, CircularProgress } from "@mui/joy";
import { Droppable } from "@hello-pangea/dnd";
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';

export default function KanbanColumn({
    col, state, droppableId, onLoadMore, renderCard, headerExtra, subHeader,
}) {
    const scrollRef = useRef(null);

    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el || state.loading || !state.hasNext) return;
        if (el.scrollHeight - el.scrollTop - el.clientHeight < 260) onLoadMore?.();
    };

    const list = (
        <>
            {state.items.map((item, i) => renderCard(item, i))}
            {state.loading && (
                <Stack alignItems="center" sx={{ py: 2 }}>
                    <CircularProgress size="sm" />
                </Stack>
            )}
            {!state.loading && state.items.length === 0 && (
                <Stack alignItems="center" spacing={0.5} sx={{ py: 4, color: 'text.tertiary' }}>
                    <InboxRoundedIcon sx={{ fontSize: 34, opacity: 0.4 }} />
                    <Typography level="body-xs">Пусто</Typography>
                </Stack>
            )}
        </>
    );

    return (
        <Sheet
            variant="soft"
            sx={{
                width: 320, minWidth: 320, maxWidth: 320,
                display: 'flex', flexDirection: 'column',
                borderRadius: '16px',
                bgcolor: 'background.level1',
                maxHeight: 'calc(100vh - 220px)',
                overflow: 'hidden',
                border: '1px solid', borderColor: 'divider',
            }}
        >
            {/* Шапка */}
            <Box sx={{ p: 1.25, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ gap: 1 }}>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: col.accent, flexShrink: 0 }} />
                        <Typography level="title-sm" sx={{ fontWeight: 800, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                            {col.title}
                        </Typography>
                        <Chip size="sm" variant="soft" color="neutral" sx={{ fontWeight: 700 }}>
                            {state.count ?? state.items.length}
                        </Chip>
                    </Stack>
                    {headerExtra}
                </Stack>
                {subHeader && <Box sx={{ mt: 1 }}>{subHeader}</Box>}
            </Box>

            {/* Тело со скроллом */}
            <Box ref={scrollRef} onScroll={handleScroll}
                 sx={{ flex: 1, overflowY: 'auto', p: 1, '&::-webkit-scrollbar': { width: 6 } }}>
                {droppableId ? (
                    <Droppable droppableId={droppableId}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    minHeight: 60,
                                    borderRadius: 12,
                                    background: snapshot.isDraggingOver ? col.softBg : 'transparent',
                                    transition: 'background .2s ease',
                                }}
                            >
                                {list}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                ) : list}
            </Box>
        </Sheet>
    );
}